export const GET_NOTIFCATION_LOGS = 'GET_NOTIFCATION_LOGS'
export const GET_NOTIFICATION_LOG = 'GET_NOTIFCATION_LOG'
